import { stringify } from "qs";

/*
 * convert object to json
 */
export const jsonFormat = (data) => {
  let config = {
    headers: { "Content-Type": "application/json" },
    data,
  };
  return config;
};

/*
 * convert object to urlencoded
 */
export const urlFormat = (data) => {
  let config = {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    data: stringify(data),
  };
  return config;
};

/*
 * convert object to formdata
 */
export const formFormat = (data) => {
  const formData = new FormData();
  for (const key in data) {
    formData.append(key, data[key]);
  }
  let config = {
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
  };
  return config;
};



// WEBPACK FOOTER //
// ./src/api/content-type.js